module.exports = __webpack_public_path__ + "img/72_6.e2800fde.png";